import * as types from '../types';

export const updateBroker = brokerData => {
  const { user, ...broker } = brokerData;
  return {
    type: types.UPDATE_BROKER_DATA,
    payload: {
      user,
      broker
    }
  };
};
